import API from 'api/helpers/client';
import type { GetKeyValuesParams, KeyValues } from './keyValues.types';

export const fetchKeyValues = async <T>({
  key,
  params,
}: GetKeyValuesParams): Promise<KeyValues<T>> =>
  (await API.get(`key-values/${key}`, { params })).data;
